import { Box, Avatar, Text, Link } from 'theme-ui'

import Twitter from '../../icons/Twitter'
import Discord from '../../icons/Discord'
import Etherscan from '../../icons/Etherscan'
import OpenSea from '../../icons/OpenSea'

export default function Row({ result, highlight }) {
    const truncatedEth = truncateEthAddress(result.address)

    const bg = highlight ? 'backgroundSunset' : 'background'
    const color = highlight ? 'text' : 'text'
    return (
        <>
            <Box
                sx={{
                    bg: bg,
                    pb: 3,
                    pt: 4,
                    color: color,
                    textAlign: 'center',
                    fontSize: 2,
                }}
                key={result.address}
            >
                {result.ranking}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    bg: bg,
                    color: color,
                    py: 3,
                    flexDirection: 'row',
                    pl: 2,
                }}
            >
                <Avatar
                    src={result.avatar}
                    sx={{
                        objectFit: 'cover',
                        width: 36,
                        height: 36,
                        mr: 3,
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        bg: bg,
                    }}
                >
                    <Text
                        sx={{
                            fontFamily: 'body',
                            textTransform: 'uppercase',
                            fontSize: 1,
                            letterSpacing: 1.2,
                        }}
                    >
                        {result.name ||
                            result.twitter_name ||
                            result.opensea_username ||
                            result.discord_username ||
                            truncatedEth}
                    </Text>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            pl: 2,
                        }}
                    >
                        {result.discord_username && (
                            <SocialButton
                                icon={<Discord width={15} />}
                                href={`https://discord.com/users/${result.discord_id}`}
                                alt={result.discord_username}
                            />
                        )}

                        {result.twitter_username && (
                            <SocialButton
                                icon={<Twitter width={15} />}
                                href={`https://twitter.com/${result.twitter_username}`}
                                alt={result.twitter_username}
                            />
                        )}

                        <SocialButton
                            icon={<Etherscan width={15} />}
                            href={`https://etherscan.io/address/${result.address}`}
                            alt={result.address}
                        />
                        <SocialButton
                            icon={<OpenSea width={15} />}
                            href={`https://opensea.io/${result.address}`}
                            alt={result.address}
                        />
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    color: color,
                    py: 3,
                    fontSize: 2,
                    fontFamily: 'monospace',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {result.discord || 0}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    display: 'flex',
                    color: color,
                    py: 3,
                    fontFamily: 'monospace',
                    fontSize: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {result.owns}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    py: 3,
                    color: color,
                    display: 'flex',
                    fontFamily: 'monospace',
                    fontSize: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                Ξ {result.avg_listed}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    py: 3,
                    fontSize: 2,
                    fontFamily: 'monospace',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: result.gainloss >= 0 ? 'green' : 'red',
                }}
            >
                Ξ {result.gainloss}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    display: 'flex',
                    color: color,
                    py: 3,
                    fontFamily: 'monospace',
                    fontSize: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                Ξ {result.spend}
            </Box>
            <Box
                sx={{
                    textAlign: 'center',
                    bg: bg,
                    py: 3,
                    display: 'flex',
                    fontFamily: 'monospace',
                    color: color,
                    fontSize: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                Ξ {result.value}
            </Box>
        </>
    )
}

function SocialButton({ icon, href, alt }) {
    return (
        <Link
            sx={{
                color: 'textDarkGrey',
                ':hover': {
                    color: 'text',
                    bg: 'backgroundDeepGrey',
                },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                ml: 0,
                width: 26,
                height: 26,
                borderRadius: 13,
            }}
            alt={alt}
            target="_blank"
            href={href}
        >
            {icon}
        </Link>
    )
}

const truncateEthAddress = (address) => {
    // Captures 0x + 4 characters, then the last 4 characters.
    const truncateRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/

    const match = address.match(truncateRegex)
    if (!match) return address
    return `${match[1]}…${match[2]}`
}
